export default [
  {
    path: '/pushCenter/groupPush',
    name: 'groupPush',
    meta: {
      title: '穿衣小程序推送',
    },
    component(resolve) {
      require(['COMPONENTS/pushCenter/groupPush/main.vue'], resolve)
    }
  },
  {
    path: '/pushCenter/icyPush',
    name: 'icyPush',
    meta: {
      title: 'ICY活动推送',
    },
    component(resolve) {
      require(['COMPONENTS/pushCenter/icyPush/main.vue'], resolve)
    }
  },
]